import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import {DevSupport} from "@react-buddy/ide-toolbox";
import {ComponentPreviews, useInitial} from "./dev/index.js";
import "./pwa/registerSW.js";
// import './interceptors/axios';


ReactDOM.createRoot(document.getElementById('root')).render(
    // <React.StrictMode>


    <Router>
        <Routes>
            <Route path="/*" element={<DevSupport ComponentPreviews={ComponentPreviews}
                                                  useInitialHook={useInitial}
            >
                <App/>
            </DevSupport>}

            />


            {/*<Route path="/*" element={<App/>}/>*/}



        </Routes>
    </Router>
    ,
)
